import {
    ADD_TEMPLATE,
    GET_TEMPLATE,
    EDIT_TEMPLATE,
    ALL_TEMPLATE
  } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const Template = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TEMPLATE:
      case GET_TEMPLATE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_TEMPLATE:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_TEMPLATE:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default Template
